import React from 'react';
import LinkMenu from 'gatsby-matrix-theme/src/components/atoms/link-menu';

export default (props) => {

  return (
    <LinkMenu
      {...props}
      listIcon={[]}
    />
  );
};